import React, { useState, useCallback } from 'react';

import {
    required, minLength, maxLength, minValue, maxValue,
    number, regex, email, choices,
    TabbedForm, FormTab, DeleteButton, useRefresh, AutocompleteInput,
    Edit, SimpleForm, TextInput, RichTextField,
    ReferenceInput, SelectInput, EditButton, NumberField,
    DateInput, BooleanInput, NumberInput, ImageInput, ImageField,
    ReferenceManyField, ReferenceField, Datagrid, TextField, BooleanField, FormDataConsumer
} from 'react-admin';
import { useForm } from 'react-final-form';
import { useStyles } from "./formStyles";
import { Button } from '@material-ui/core';

export const AddressFields = ({ formData,
    countryField,
    stateField,
    cityField,
    countryLabel,
    stateLabel,
    cityLabel,
    showAsAbove
    , ...rest }) => {
    const form = useForm();
    const classes = useStyles({});
    const handleSame=()=>{
        form.change("permanentAddress1",formData.presentAddress1);
        form.change("permanentAddress2",formData.presentAddress2);
        form.change("permanentPinCode",formData.presentPinCode);
        form.change("permanentCountryId",formData.presentCountryId);
        form.change("permanentStateId",formData.presentStateId);
        form.change("permanentCityId",formData.presentCityId);
    }
    return (
        <div className="address-field-parent" >
            
            <ReferenceInput variant="outlined" label={countryLabel}  source={countryField} reference="countries"
                onChange={(v) => {
                    console.log(v);
                    form.change(stateField, 0);
                    form.change(cityField, 0);
                }}
                sort={{ field: 'countryName', order: 'ASC' }}
                filterToQuery={searchText => ({ 'countryName~like': searchText })} 
                fullWidth={true} perPage={500}>
                
                <AutocompleteInput variant="outlined"
                                                                optionText={record =>
                                                                    `${record?.countryName}`
                                                                }
                                                            />
    
            </ReferenceInput>
            <div style={{width:"5%"}}></div>
            <ReferenceInput variant="outlined" label={stateLabel} source={stateField}
                reference="states" perPage={500}
                filter={{ countryId: (formData[countryField]) ? formData[countryField] : 0 }}
                onChange={(v) => {
                    //console.log(v);
                    form.change(cityField, 0);
                }}
                sort={{ field: 'stateName', order: 'ASC' }}
                filterToQuery={searchText => ({ 'stateName~like': searchText })} 
                shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                fullWidth={true} >
                
                <AutocompleteInput variant="outlined"
                                                                optionText={record =>
                                                                    `${record?.stateName}`
                                                                }
                                                            />
    
            </ReferenceInput>
                                                                <div style={{width:"5%"}}></div>
            <ReferenceInput  label={cityLabel}
                filter={{ stateId: (formData[stateField]) ? formData[stateField] : 0 }}
                sort={{ field: 'cityName', order: 'ASC' }}
                 source={cityField} reference="cities" perPage={500}
                shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                fullWidth={true} 
                filterToQuery={searchText => ({ 'cityName~like': searchText })} 
                >
                
                <AutocompleteInput variant="outlined"
                                                                optionText={record =>
                                                                    `${record?.cityName}`
                                                                }
                                                            />
    
            </ReferenceInput>
           {showAsAbove && <Button variant="contained" color="primary" onClick={handleSame} > Same As Above </Button>}
        </div>
    )
}
